import { ekDomain, ROUTES } from '@/configs/constants';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { isPathEk } from '@/utils/routes';
import AnimateButton from './button-custom/AnimateButton';

export default function BackToSigninBtn() {
    // other
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const isEk = isPathEk(pathname);
    return (
        <div className='flex justify-center'>
            <Link
                to={isEk ? `/${ekDomain}${ROUTES.signin.href}` : ROUTES.signin.href}
            >
                <AnimateButton
                    outline
                    side='left'
                    contentComp={t('button.back_to_signin')}
                    parentClassName='h-[48px]'
                />
            </Link>
        </div>
    );
};
